<script>

  import auth from '@/services/auth'

  const { signIn } = auth

  export default {
    name: 'LoginScene',
    props: {
    },
    data () {
      return {
        email: null,
        password: null,
        isLoading: false,
        hasError: false,
      }
    },
    methods: {
      requestAuth () {
        this.isLoading = true
        signIn({ email: this.email, password: this.password })
          .then(
            () => {
              const redirect = decodeURIComponent(this.$route.query.redirect)
              const validRedirection = this.$router.resolve({ path: redirect }).route.matched.length
              this.$router.push(redirect && validRedirection ? { path: redirect } : { name: 'intro' })
            },
            (e) => {
              console.log(e)
              this.hasError = true
            }
          )
          .then(() => { this.isLoading = false })
      },
    },
  }
</script>

<template lang="pug">

div.login-scene
  a.logo(href='/')
    img._margin-icon(src="~@/assets/logo-noir.svg", width="90px")
  section.mainsection.hero.is-fullheight
    .hero-body
      .container
        .columns.is-vcentered
          .column.is-11.is-offset-1
            h1.bigtitle.title.is-1
              b Robert veut lire
            h2.subtitle.is-3 Client
        .columns
          .column.is-4.is-offset-1
            .box(:class="{'is-shaking': hasError}")
              form(@submit.prevent="requestAuth({ email, password })", novalidate, autocomplete="on")
                label.label Courriel
                p.control
                  input.input(:class="{'is-danger': hasError}", v-model="email", name="email", type='text', placeholder='courriel@exemple.com')
                label.label Mot de passe
                p.control
                  input.input(:class="{'is-danger': hasError}", v-model="password", name="password", type='password', placeholder='●●●●●●●')
                hr
                p.subtitle.is-6.is-danger(v-show="hasError") Identifiants invalides.
                p.control
                  button.button.is-primary(type="submit", :class="{'is-loading': isLoading, 'is-danger': hasError}") {{ !hasError ? 'Connexion' : 'Réessayer'}}
            p.has-text-centered
          .column.is-5.is-offset-1
            div.content.infos
              p Pour obtenir les suggestions gratuites de Robert veut lire, vous devez avoir un compte.
              p Vous pouvez nous le demander en nous écrivant à #[a(href="mailto:ici@robertveutlire.com", style="color: white") ici@robertveutlire.com] ou simplement vous connecter avec l’identifiant suivant:
              table.is-outline
                tr
                  td #[b Courriel]
                  td jeteste@robertveutlire.com
                tr
                  td #[b Mot de passe]
                  td jaimerobert
              //- a(href='register.html') Register an Account
              //- a(href='#') Mot de passe oublié ?
              //- a(href='#') Need help?

</template>

<style lang="postcss" scoped>

  .login-scene {
    font-family: 'Open Sans', sans-serif;
    & .mainsection {
      background-color: rgb(255,89,8);
    }
    & .label{
      margin-top:10px;
      margin-bottom:5px;
    }

    & .button:hover{

    }

    & .content > p{
      line-height:1.8em;
      font-size:1.2rem;
    }

    & .bigtitle {
      font-size:3.4em;
    }
    & .infos {
      font-size: 1.3em;
    }
    & .is-outline {
      position: relative;
      font-size: .8em;
      table-layout: auto;
      width: auto;
      margin-top:15px;
      &:after {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        content: "";
        border: 1px solid rgb(74,74,74);
        border-radius: 8px;
      }
      display: inline-table;
      border-collapse:collapse;
      & td {
        padding: 4px 10px;
        border: none;
        width: 1px;
        white-space: nowrap;
        padding: 12px;
      }
    }

    & .logo {
      position: absolute;
      top: 0;
      left: 0;
      margin: 40px;
    }
    & .is-shaking {
      animation-name: shake;
    }
  }

</style>



// WEBPACK FOOTER //
// login-scene.vue?e8f0f01c